import { SpamFieldRules } from '@netfront/ui-library';

const CONTACT_FORM_BLOCK_CSS_IDENTIFIERS = Object.freeze({
  form: 'c-contact-form',
});

const CONTACT_FORM_DEFAULTS = Object.freeze({
  heading: 'Contact',
});

/**
 * Substring matched, case insensitively, so keep each entry to the part of the
 * pitch that never varies.
 *
 * Deliberately excludes crypto/bitcoin on its own: wallet address QR codes are
 * a real enquiry for this product.
 */
const CONTACT_FORM_BLOCKED_PHRASES = Object.freeze([
  'seo services',
  'seo expert',
  'seo agency',
  'backlink',
  'guest post',
  'link building',
  'rank your website',
  'rank on google',
  'first page of google',
  'buy followers',
  'buy traffic',
  'crypto investment',
  'binary options',
  'forex',
  'casino',
  'payday loan',
  'loan offer',
  'work from home',
  'viagra',
  'cialis',
  'escort service',
  'telegram @',
  'whatsapp +',
]);

/**
 * Applied on top of the yup resolver, which still owns "is it required".
 *
 * Only the fields a human writes prose into get the content heuristics; the
 * phone number is checked for links and markup alone, since a repeated-run rule
 * would reject numbers such as 1300 000 000.
 */
const CONTACT_FORM_SPAM_RULES: SpamFieldRules[] = [
  {
    field: 'firstName',
    rules: {
      noGibberish: true,
      noHtml: true,
      noMixedScripts: true,
      noRepeatedCharacters: true,
      noUrls: true,
    },
    errorMessage: 'Please enter a valid first name',
  },
  {
    field: 'lastName',
    rules: {
      noGibberish: true,
      noHtml: true,
      noMixedScripts: true,
      noRepeatedCharacters: true,
      noUrls: true,
    },
    errorMessage: 'Please enter a valid last name',
  },
  {
    field: 'email',
    rules: {
      noHtml: true,
      noMixedScripts: true,
      noUrls: true,
    },
    errorMessage: 'Please enter a valid email',
  },
  {
    field: 'phoneNumber',
    rules: {
      noHtml: true,
      noUrls: true,
    },
    errorMessage: 'Please enter a valid phone number',
  },
  {
    field: 'organisationName',
    rules: {
      blockedPhrases: [...CONTACT_FORM_BLOCKED_PHRASES],
      noGibberish: true,
      noHtml: true,
      noMixedScripts: true,
      noRepeatedCharacters: true,
      noUrls: true,
    },
    errorMessage: 'Please enter a valid organisation name',
  },
  {
    field: 'message',
    rules: {
      blockedPhrases: [...CONTACT_FORM_BLOCKED_PHRASES],
      noGibberish: true,
      noHtml: true,
      noMixedScripts: true,
      noRepeatedCharacters: true,
      noUrls: true,
    },
  },
];

export { CONTACT_FORM_BLOCK_CSS_IDENTIFIERS, CONTACT_FORM_BLOCKED_PHRASES, CONTACT_FORM_DEFAULTS, CONTACT_FORM_SPAM_RULES };
